import React, { useState, useEffect } from "react";
import LeaveTable from "./components/LeaveTable";
import { useDispatch, useSelector } from "react-redux";
import SummaryHeader from "components/header/SummaryHeader";
import SummaryItem from "components/header/SummaryItem";
import LeaveForm from "./components/LeaveForm";
import PopupButton from "components/button/PopupButton";
import { DATE_FORMAT, ROLE_EMPLOYEE } from "variables/constants";
import { MODULE_LEAVE } from "variables/modules";
import { DatePicker } from "antd";
import { getLeaveCreditForecastList } from "../../../redux/leavecreditforecast/leaveCreditForecastState";

const { RangePicker } = DatePicker;

const Leaves = ({
}) => {
	const dispatch = useDispatch();
	const [dateRange, setDateRange] = useState(null);
	const authUser = useSelector((state) => state.auth.user);
	const forecastList = useSelector((state) => state.leaveCreditForecast.leaveCreditForecastList?.items);
	
	const forecastVL = forecastList?.find(
		(item) => item.lcf_leave_type_id === 29
	);

	const forecastSL = forecastList?.find(
		(item) => item.lcf_leave_type_id === 30
	);
	
	const summaryItems = [
		{
			title: "Vacation Leave",
			total: forecastVL?.lcf_current_balance ?? 0,
			icon: "Plane",
			detail: "remaining"
		},
		{
			title: "Sick Leave",
			total: forecastSL?.lcf_current_balance ?? 0,
			icon: "ScanHeart",
			detail: "remaining"
		},
		{
			title: "Forecasted VL",
			total: forecastVL?.lcf_forecast_balance ?? 0,
			icon: "CalendarCheck2",
			detail: "next month",
		},
		{
			title: "Forecasted SL",
			total: forecastSL?.lcf_forecast_balance ?? 0,
			icon: "CalendarHeart",
			detail: "next month",
		},
	];

	useEffect(() => {
		dispatch(getLeaveCreditForecastList({
			paginate: 10
		}));
	}, [dispatch]);

	return (
	    <div className="space-y-6">
			<SummaryHeader
				title="Leave History"
				iconName="ClipboardList"
				description="View your past and pending leave requests"
				color={"cyan"}
        		rightNav={
							<PopupButton 
								id="add_leave" 
								title="Request Leave"
								description="Submit a new leave request"
								label="Request Leave" 
								btnClass="btn-leave" 
								action="add"
								moduleId={MODULE_LEAVE}
								iconName="FilePlusCorner"
								useCustomClass={true}
							>
								<LeaveForm recordId="0" mode="edit"/>
							</PopupButton>
				}
			>
				{authUser?.user_level === ROLE_EMPLOYEE && (
					<div className="summary-item-container">
						{summaryItems.map((item)=>(
							<SummaryItem
								key={item.title}
								title={item.title}
								iconName={item.icon}
								display={
									<div className="flex items-center gap-2">
										<p className="text-xl font-bold">
												{Number(item.total).toLocaleString(undefined, {
													minimumFractionDigits: 0,
													maximumFractionDigits: 2,
												})} 
										</p>
										<p className="text-xs">
											{item?.detail}
										</p>
									</div>
								}
							/>
						))}
					</div>
				)}
			</SummaryHeader>
			<div className="mt-5 w-full md:w-1/2 max-w-[350px]">
				<RangePicker
					format={DATE_FORMAT}
					onChange={(dates) => setDateRange(dates)}
					className="input-field"
					allowClear
				/>
			</div>
			<div className="p-4 border rounded-2xl">
				<LeaveTable dateRange={dateRange}/>
			</div>
	    </div>
    );
};

export default Leaves;